import { ApolloProvider } from '@apollo/client';

import CommonReports from '../features/reports/common-reports/CommonReports';
import { GeneratedReports } from '../features/reports/generated-reports-table/GeneratedReports';
import { client } from '../graphql/client';

type Props = {
  employerId: string;
};

export const ReportsApp: React.FC<Props> = props => (
  <ApolloProvider client={client}>
    <CommonReports {...props} />
    <GeneratedReports {...props} />
  </ApolloProvider>
);
